export const roles = {
  admin: 'ROLE_ADMIN',
  collectionEditor: 'ROLE_COLLECTION_EDITOR',
  creator: 'ROLE_RECIPE_CREATOR',
  newsAuthor: 'ROLE_NEWS_AUTHOR',
  reviewer: 'ROLE_RECIPE_REVIEWER',
  user: 'ROLE_USER',
  transferAgent: 'ROLE_TRANSFER_AGENT',
};
